import React, { useState } from "react";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { Icon } from "../../components";
import { PickerOption } from "../../offering/picker";
import { useAnalytics } from "../../lib/analytics/analytics";

interface AttendeesPickerProps {
  options: PickerOption[];
  onChange: (value: string) => void;
  value?: number;
}

export function AttendeesPicker(props: AttendeesPickerProps) {
  const { fbt } = useI18n();
  const analytics = useAnalytics();
  const { options, onChange, value } = props;
  const [selectedCapacity, setSelectedCapacity] = useState<string>(
    value?.toString() || ""
  );

  return (
    <div className="checkout-box-picker-view">
      <Dropdown
        as={ButtonGroup}
        className="checkout-box-picker row"
        id="number-of-guest-picker"
        size="lg"
        onSelect={(value: any) => {
          onChange(value);
          setSelectedCapacity(value);
          analytics.event(
            "Attendees Select Click",
            {
              Attendees: value,
              Source: "WL",
            },
            { onlyProviders: ["mixpanel", "customerio"] }
          );
        }}
      >
        <Dropdown.Toggle>
          <div className="row">
            <div className="col-10 checkout-box-picker-placeholder">
              <span className="row fw-bold text-uppercase checkout-box-picker-placeholder__label">
                {fbt("Attendees")}
              </span>
              <span className="row checkout-box-picker-selected">
                {selectedCapacity ? (
                  selectedCapacity
                ) : (
                  <span className="fw-lighter checkout-box-picker-selected__placeholder">
                    {fbt("Select number of guests")}
                  </span>
                )}
              </span>
            </div>
            <div className="checkout-box-picker-icon">
              <Icon name="fi-chevron-down" size={24} />
            </div>
          </div>
        </Dropdown.Toggle>
        <DropdownMenu>
          <Dropdown.Header>
            <div className="dropdown-header">
              <span className="row fw-bold text-uppercase">
                {fbt("Select number of guests")}
              </span>
            </div>
          </Dropdown.Header>
          {options.map((opt, index) => (
            <>
              <Dropdown.Item
                as="button"
                eventKey={opt.value}
                active={opt.value === parseInt(selectedCapacity)}
              >
                <div className="row quantity-picker-option px-1">
                  <span className="col-6 align-self-start name">
                    {opt.label}
                  </span>
                </div>
              </Dropdown.Item>
              {index !== options.length - 1 && <Dropdown.Divider />}
            </>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
